import React from 'react';
import CardSimple from '../../../../../components/basic/CardSimple';

const Hardware = () => {
    return (
        <div id="error-message">
            <br />
            <div>
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>Message: "There is a problem with your hardware, contact your system administrator"</h2>
                        <br />
                        <p>TechPOS is designed to keep on running if there isn’t communication with the hardware. If you get the following message: There is a problem with your hardware, contact your system administrator make sure you follow this steps:</p>
                        <h3 style={{ color: "#000" }}>Cable Connections</h3>
                        <p>
                            Make sure all the cables are well connected to the computer, the RJ-11 cable from the drawer connected to the thermal printer, the printers and the
                            scale connected to the computer and connected to the power outlet.
                        </p>
                        <h3 style={{ color: "#000" }}>Ports Configuration</h3>
                        <ul>
                            <li>Stop the Cash Register Service (if running)</li>
                            <li>Open the file CashRegisterService.exe.config with Notepad</li>
                            <li>Open Device Manager and take a note of the COM port(under Ports (CON & LPT)), Thermal Printer and Label Printer (under Printer queues)</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/Hardware/hardware1.PNG" width="600" />
                            <li>Make sure the names matches on the section "appSettings" if they don't match, change them to match the names on device manager</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/Hardware/hardware2.PNG" width="600" />
                            <li>Save the changes, restart the service and reload the page.</li>
                        </ul>
                        <p>NOTE: If it doesn’t work and you are sure the cables are connected and, that the ports names
                            matches the ones in device manager, cleaning the browsing history can help to fix the issue. For
                            instructions please refer to the Cache Issue under the General category.
                        </p>
                    </div>
                </CardSimple>
            </div>
            <div id="label-printer">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>The label printer doesn't print properly</h2>
                        <ul>
                            <li>Go to Windows Settings {`>`} Devices</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/Hardware/hardware3.PNG" width="550" />
                            <li>On the side bar click on Printers and Scanners</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/Hardware/hardware4.PNG" width="250" />
                            <li>
                                Locate the label Printer. (NOTE: If you have moved the port of the label printer the printer
                                name will be ZDesigner TLP 2824 (Copy X), else the name would be ZDesigner TLP 2824.
                                Please corroborate the name on Device Manger {`>`} Printer queues.)
                            </li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/Hardware/hardware5.PNG" width="550" />
                            <li>Clock on Manage</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/Hardware/hardware6.PNG" width="550" />
                            <li>Click on Printing Preferences</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/Hardware/hardware7.PNG" width="300" />
                            <li>Click on Tools</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/Hardware/hardware8.PNG" width="400" />
                            <li>Select Load Factory Defaults. Click on Send.</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/Hardware/hardware9.PNG" width="450" />
                            <li>Click on Apply</li>
                            <li>Click OK</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="ip-address">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>IPv6 Address</h2>
                        <p>TechPOS doesn’t work with IPv6 addresses, if when configuring a device you get an IPv6 address, follow the next steps to deactivate it:</p>
                        <ul>
                            <li>Go to Control Panel</li>
                            <li>Click on Network and Internet</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/Hardware/hardware10.PNG" width="350" />
                            <li>Select Network and Sharing Center</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/Hardware/hardware11.PNG" width="550" />
                            <li>On the left side of the screen, click on Change adapter settings.</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/Hardware/hardware12.PNG" width="250" />
                            <li>From the new window, choose the active Internet connection (if you are using a cable to
                                connect to the internet click on Ethernet, if you are using Wi-Fi, click on Wi-Fi).</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/Hardware/hardware13.PNG" width="550" />
                            <li>Note: FOR THE NEXT STEPS YOU NEED ADMINISTRATOR PERMISSIONS</li>
                            <li>From the pop-up window click on Properties (you might need to provide admin credentials).</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/Hardware/hardware14.PNG" width="450" />
                            <li>From the pop-up window called Wi-Fi/Ethernet Properties and, under Networking tab,
                                scroll down until Internet Protocol version 6 (TCP/IPv6) and make sure the check box is
                                unmarked (if marked click on the check box to remove the mark), click OK.
                            </li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/Hardware/hardware15.PNG" width="450" />
                            <li>Close Wi-Fi/Ethernet Properties, Close Control Panel.</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
        </div>
    )
}

export default Hardware;